import Dexie, { Table } from 'dexie'
import _ from 'lodash'
import {
  dbOptions,
  CHECK_MAX_STORAGE_MESSAGE,
  CURRENT_VERSION,
  ASSET_TABLE_COLUMNS,
} from './config'
import { Asset } from './type'
import Worker from './db.worker'

class Database extends Dexie {
  public asset!: Table<Asset, string>
  /** 最大存储限制 */
  private maxStorage: number
  /** 单条数据最大存储限制 */
  private maxDataSize: number

  private worker: Worker

  constructor(options: Partial<typeof dbOptions> = {}) {
    const { name, version, maxStorage, maxDataSize } = Object.assign(
      {},
      dbOptions,
      options,
    )

    super(name)
    this.version(version).stores({
      asset: ASSET_TABLE_COLUMNS,
    })

    this.maxStorage = maxStorage
    this.maxDataSize = maxDataSize

    // this.worker = new Worker(new URL('./db-worker.ts', import.meta.url))
    this.worker = new Worker()

    this.hooks()
  }

  private hooks() {
    this.asset.hook('creating', (primKey, obj, transaction) => {
      if (this.maxDataSize !== -1 && obj.size > this.maxDataSize) {
        console.log(`单条数据超过最大存储限制${this.maxDataSize}，不存储`)
        transaction.abort()
      }

      this.debCheckMaxStorage()
    })
  }

  debCheckMaxStorage = _.debounce(() => {
    this.worker.postMessage({
      action: CHECK_MAX_STORAGE_MESSAGE,
      option: {
        maxStorage: this.maxStorage,
      },
    })
  }, 300)
}

export const db = new Database({
  version: CURRENT_VERSION,
  // 10M
  // maxDataSize: 1024 * 1024 * 10,
  // 1G
  maxStorage: 1024 * 1024 * 1024,
})
